module.exports = __webpack_public_path__ + "static/img/senior-bg.3e42157.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/all-versions/senior-bg.png
// module id = 895
// module chunks = 2